import { Component, Input } from '@angular/core';
import { InputComponent } from '../input/input.component';

/**
 * Radio-Button component to show radio buttons with proper validation.
 *
 * @example
 * <cfe-input-radio-wrapper>
 *               <cfe-input-radio
 *                           [control]="formControl"
 *                           [name]="'name'"
 *                           [value]="'value'"
 *                           [label]="'Radio Button label'"
 *                           [id]="'description'"
 *                           [tabIndex]="1"
 *                           [disabled]="false"
 *                           [notMarkAsRequired]="false">
 *               </cfe-input-radio>
 * </cfe-input-radio-wrapper>
 *
 */

@Component({
	selector: 'cfe-input-radio',
	templateUrl: './input-radio.component.html',
	styleUrls: ['./input-radio.component.scss']
})
export class InputRadioComponent extends InputComponent {
	/**
	 * Name attribute of the radio button
	 */
	@Input() name: string;

	/**
	 * Name attribute of the radio button
	 */
	@Input() placeholder: string;

	/**
	 * Value of the radio button
	 */
	@Input() value: any = null;

	constructor() {
		super();
	}

	cfeOnInit() {}
}
